var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewUsersWeek(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.208 8.12297L12.5622 9.47713L15.2705 6.7688",
    stroke: "#00C49A",
    strokeWidth: 1.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2087 14.8938V13.5396C11.2087 12.8213 10.9233 12.1325 10.4154 11.6246C9.9075 11.1166 9.21862 10.8313 8.50033 10.8313H4.43783C3.71953 10.8313 3.03066 11.1166 2.52274 11.6246C2.01483 12.1325 1.72949 12.8213 1.72949 13.5396V14.8938",
    stroke: "#00C49A",
    strokeWidth: 1.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46908 8.12297C7.96485 8.12297 9.17741 6.9104 9.17741 5.41463C9.17741 3.91886 7.96485 2.7063 6.46908 2.7063C4.9733 2.7063 3.76074 3.91886 3.76074 5.41463C3.76074 6.9104 4.9733 8.12297 6.46908 8.12297Z",
    stroke: "#00C49A",
    strokeWidth: 1.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewUsersWeek);
export default __webpack_public_path__ + "static/media/new-users-week.beda535d4b94ffe8709de69a1a38b885.svg";
export { ForwardRef as ReactComponent };